
import {merge as observableMerge, fromEvent as observableFromEvent,  BehaviorSubject ,  Observable } from 'rxjs';

import {map, debounceTime, distinctUntilChanged} from 'rxjs/operators';
import { NotificationsService } from './../activenotifications/notifications.service';
import { NotificationDeliveryStatus } from './../activenotifications/qaticketnotification.model';
import { QuestionService } from './../../shared/questionService';
import { QATicket, SendFeedBack } from './../../shared/qaTicket';
import { LocalStorage } from './../../shared/localstorage.service';
import { Logger } from './../../shared/logger.service';
import { Component, ElementRef, ViewChild, OnInit, ChangeDetectorRef } from '@angular/core';
import { DataSource } from '@angular/cdk/collections';
import { MatPaginator, MatSort, MatTable, MatDialog, ErrorStateMatcher } from '@angular/material';
import { MatSnackBar } from  '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { DatePipe } from '@angular/common';






import { AuthenticationService } from '../../shared/authentication.service';
import { InfodialogComponent } from '../../dialogs/infodialog/infodialog.component';

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid && (control.dirty || control.touched));
  }
}

@Component({
  selector: "app-notificationdeliverystatus",
  templateUrl: "./notificationdeliverystatus.component.html",
  styleUrls: ["./notificationdeliverystatus.component.scss"]
})

export class NotificationDeliveryStatusComponent implements OnInit {
  screen = false;
  isDataAvailable = true;
  public fromdate: Date;
  public todate: Date;
  displayedColumns = ['GCTicketNumber', 'IsDelivered', 'SendToEmailAddress', 'NotificationCreatedBy', 'Creation'];
  dataChange: BehaviorSubject<NotificationDeliveryStatus[]> = new BehaviorSubject<NotificationDeliveryStatus[]>([]);
  get data(): NotificationDeliveryStatus[] { return this.dataChange.value; }
  dataSource: NotificationDeliveryStatusDataSource | null;
  public errormessage: string | null;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('filter') filter: ElementRef;

  constructor(
    public dialog: MatDialog,
    public service: NotificationsService,
    public cdRef: ChangeDetectorRef,
    public router: Router,
    public route: ActivatedRoute,
    public snackBar: MatSnackBar,
    public logger: Logger,
    public localStorage: LocalStorage,
    public questionService: QuestionService,
    public authService: AuthenticationService,
    public datepipe: DatePipe) {
  }

  startDate = new FormControl('', [Validators.required]);
  endDate = new FormControl('', [Validators.required]);
  matcher = new MyErrorStateMatcher();

  getAllNotifications() {
    this.service.getNotificationDeliveryStatusForToday().subscribe(results => {
      this.screen = true;
      this.dataChange.next(results);
      this.isDataAvailable = true;
      this.cdRef.detectChanges();
      this.initSource();
      this.screen = false;
    });
  }

  ngOnInit() {
    this.getAllNotifications();
  }

  initSource() {
    
    this.dataSource = new NotificationDeliveryStatusDataSource(this, this.paginator, this.sort);
    observableFromEvent(this.filter.nativeElement, 'keyup').pipe(
      debounceTime(150),
      distinctUntilChanged(),)
      .subscribe(() => {
        if (!this.dataSource) { return; }
        this.dataSource.filter = this.filter.nativeElement.value;
      });
    this.cdRef.detectChanges();
  }

  searchClick() {
    
    if (this.fromdate == null && this.todate == null) {
      this.startDate.invalid;
      this.endDate.invalid;
      this.startDate.markAsDirty();
      this.endDate.markAsDirty();
      this.errormessage = "This field is required";
      return;
    }
    else if (this.fromdate == null) {
      this.startDate.invalid;
      this.errormessage = "This field is required";
      return this.startDate.markAsDirty();
    }
    else if (this.todate == null) {
      this.endDate.invalid;
      this.errormessage = "This field is required";
      return this.endDate.markAsDirty();
    }

    else {

      var startDateForDateDiff = new Date(this.datepipe.transform(this.fromdate, 'MM/dd/yyyy'));
      var endDateForDateDiff = new Date(this.datepipe.transform(this.todate, 'MM/dd/yyyy'));
      var startDateForApi = this.datepipe.transform(this.fromdate, 'MM/dd/yyyy');
      var endDateForApi = this.datepipe.transform(this.todate, 'MM/dd/yyyy')
      var dateDifference = Math.abs(startDateForDateDiff.getTime() - endDateForDateDiff.getTime());
      var diffDays = Math.ceil(dateDifference / (1000 * 3600 * 24));
      if (diffDays >= 30) {
        let dialogRef = this.dialog.open(InfodialogComponent, {
          width: '600px',
          data: {
            title: 'Alert',
            content: 'You can search for durations only up to 30 days.'
          }
        });
        return;

      }
      else {
        this.service.getNotificationDeliveryStatusByDate(startDateForApi, endDateForApi).subscribe(results => {
          this.dataChange.next(results);
          this.isDataAvailable = true;
          this.cdRef.detectChanges();
          this.initSource();

        });
      }
    }
  }
}

export class NotificationDeliveryStatusDataSource extends DataSource<any> {
  
  _filterChange = new BehaviorSubject('');
  get filter(): string { return this._filterChange.value; }
  set filter(filter: string) { this._filterChange.next(filter); }

  dataChange: BehaviorSubject<NotificationDeliveryStatus[]> = new BehaviorSubject<NotificationDeliveryStatus[]>([]);
  get data(): NotificationDeliveryStatus[] { return this.dataChange.value; }

  filteredData: NotificationDeliveryStatus[] = [];
  renderedData: NotificationDeliveryStatus[] = [];

  constructor(private component: NotificationDeliveryStatusComponent,
    private _paginator: MatPaginator,
    private _sort: MatSort) {
    super();
    super();
    this._filterChange.subscribe(() => this._paginator.pageIndex = 0);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<NotificationDeliveryStatus[]> {
    // Listen for any changes in the base data, sorting, filtering, or pagination
    const displayDataChanges = [
      this.component.dataChange,
      this._sort.sortChange,
      this._filterChange,
      this._paginator.page,
    ];

    return observableMerge(...displayDataChanges).pipe(map(() => {
      this.filteredData = this.component.data.slice().filter((item: NotificationDeliveryStatus) => {
        const searchStr = (item.SentTo + item.GCTicketNumber).toLowerCase();
        return searchStr.indexOf(this.filter.toLowerCase()) !== -1;
      });
      // Sort filtered data
      const sortedData = this.sortData(this.filteredData.slice());

      // Grab the page's slice of the filtered sorted data.
      const startIndex = this._paginator.pageIndex * this._paginator.pageSize;
      this.renderedData = sortedData.splice(startIndex, this._paginator.pageSize);
      return this.renderedData;
    }));
  }

  disconnect() { }

  /** Returns a sorted copy of the database data. */
  sortData(data: NotificationDeliveryStatus[]): NotificationDeliveryStatus[] {
    if (!this._sort.active || this._sort.direction === '') { return data; }

    return data.sort((a, b) => {
      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'GCTicketNumber': [propertyA, propertyB] = [a.GCTicketNumber, b.GCTicketNumber]; break;
        case 'NotificationCreatedBy': [propertyA, propertyB] = [a.CreatedBy, b.CreatedBy]; break;
      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;

      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    });
  }
}
